export default __webpack_public_path__ + "static/media/hero2.57fa962a.gif";